import { render } from "./IntegerControlRenderer.vue?vue&type=template&id=5a0a090e&ts=true"
import script from "./IntegerControlRenderer.vue?vue&type=script&lang=ts"
export * from "./IntegerControlRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__